import React from "react";

export function useQuerySwitch(key) {
    const query = useQuery();
    return query.get(key.toLocaleLowerCase()) && query.get(key.toLocaleLowerCase()) == "true" && query.get(key.toLocaleLowerCase()) != "false";
}

export function useQueryNumber(key, defaultValue) {
    const query = useQuery();
    try {
        return query.get(key.toLocaleLowerCase()) ? parseInt(query.get(key.toLocaleLowerCase())) : defaultValue;
    } catch {
        return defaultValue;
    }
}

export function useQuery() {
    return React.useMemo(() => new URLSearchParams(window.location.search.toLocaleLowerCase()), [window.location.search]);
}

export function usePath() {
    return React.useMemo(() => window.location.pathname, [window.location.pathname]);
}

export function useIFrame() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

export const NotFound = () => {
    return (
        <div className="flex items-center justify-center h-full w-full">
            <span className="text-4xl font-bold text-text">404</span>
        </div>
    );
};

export const CoerceToArrayBuffer = (input) => {
    if (typeof input === "string") {
        // base64url to base64
        input = input.replace(/-/g, "+").replace(/_/g, "/");

        // base64 to Uint8Array
        var str = window.atob(input);
        var bytes = new Uint8Array(str.length);
        for (var i = 0; i < str.length; i++) {
            bytes[i] = str.charCodeAt(i);
        }
        input = bytes;
    }

    // Array to Uint8Array
    if (Array.isArray(input)) {
        input = new Uint8Array(input);
    }

    // Uint8Array to ArrayBuffer
    if (input instanceof Uint8Array) {
        input = input.buffer;
    }

    // error if none of the above worked
    if (!(input instanceof ArrayBuffer)) {
        throw new TypeError("could not coerce to ArrayBuffer");
    }

    return input;
};

export const CoerceToBase64Url = (input) => {
    // Array or ArrayBuffer to Uint8Array
    if (Array.isArray(input)) {
        input = Uint8Array.from(input);
    }

    if (input instanceof ArrayBuffer) {
        input = new Uint8Array(input);
    }

    // Uint8Array to base64
    if (input instanceof Uint8Array) {
        var str = "";
        var len = input.byteLength;

        for (var i = 0; i < len; i++) {
            str += String.fromCharCode(input[i]);
        }
        input = window.btoa(str);
    }

    if (typeof input !== "string") {
        throw new Error("could not coerce to string");
    }

    // base64 to base64url
    // NOTE: "=" at the end of challenge is optional, strip it off here
    input = input.replace(/\+/g, "-").replace(/\//g, "_").replace(/=*$/g, "");

    return input;
};
